<template>
<!--  <v-layout style="border: 2px solid grey; border-radius: 3px; " -->
<!--            class="subtitle-2 font-weight-light">-->
  <v-layout>
    <v-icon class="green--text">add_location_alt</v-icon>
  <vue-google-autocomplete
        ref="autocomplete"
        id="map"
        class="headline"
        placeholder="Search address..."
        v-on:placechanged="getAddressData"
        country="ca"
    ></vue-google-autocomplete>
  </v-layout>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { VueGoogleAutocomplete },

  data: function () {
    return {
      location: "",
    };
  },

  // mounted() {
  //   // To demonstrate functionality of exposed component functions
  //   // Here we make focus on the user input
  //   this.$refs.address.focus();
  // },

  methods: {
    getAddressData (addressData, placeResultData) {
      let local = {}
      local.formatted_address = placeResultData.formatted_address
      local.name = placeResultData.name
      local.url = placeResultData.url
      local.created = Date.now()
      this.location = addressData;
      this.$emit('locationFound', local)
      //console.log(this.$refs.autocomplete)
      this.$refs.autocomplete.$refs.autocomplete.value = ''
    },
  },
};
</script>
